import { clamp } from '@brickup/shared/utils'
import { cn } from './cn'

/** How far along something is, 0–100. */
export function ProgressBar({
  percentage,
  showPercentage = false,
  size = 'md',
  className,
}: {
  percentage: number
  showPercentage?: boolean
  /** `sm` for a bar beside running text, where 8 px reads as a block. */
  size?: 'sm' | 'md'
  className?: string
}) {
  const clamped = clamp(percentage, 0, 100)
  // The bar is the only thing that sees the overflow — it clamps it. Asking
  // the caller to pass the colour as well would be two places deciding one
  // fact, and the second one is easy to forget.
  const overflowed = percentage > 100

  return (
    <div className={cn('flex flex-row items-center gap-2.5', className)}>
      <div
        role="progressbar"
        aria-valuenow={Math.round(clamped)}
        aria-valuemin={0}
        aria-valuemax={100}
        className={cn(
          'w-full overflow-hidden rounded-full bg-border',
          size === 'sm' ? 'h-1' : 'h-2',
        )}
      >
        <div
          className={cn(
            'h-full rounded-full transition-[width] duration-500 ease-out',
            overflowed ? 'bg-destructive' : 'bg-primary',
          )}
          style={{ width: `${clamped}%` }}
        />
      </div>
      {showPercentage ? (
        <span className="w-9 shrink-0 text-right text-xs tabular-nums text-muted-foreground">
          {Math.round(clamped)}%
        </span>
      ) : null}
    </div>
  )
}
